/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */


import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";


if ( document.querySelectorAll('.imageswiper').length ){

	const splide = new Splide(".imageswiper", {
		type: "loop",
		drag: "free",
		focus: "center",
		perPage: 2.5,
		pauseOnFocus: false,
		gap:10,
		autoScroll: {
			speed: 2,
			autoStart: true,
		},
		breakpoints: {
			768: {
				perPage: 1,
			},
			1200: {
				perPage: 1.5,
			},
		},
	});

	splide.mount({AutoScroll});

}


